var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpeneyeBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39888 13.6683C6.06408 16.3218 10.7122 20 16.0003 20C21.2884 20 25.9356 16.3218 28.6009 13.6683C29.3038 12.9685 29.6564 12.6174 29.8801 11.9302C30.04 11.44 30.04 10.5601 29.8801 10.0699C29.6564 9.38276 29.3038 9.03161 28.6009 8.3317C25.9356 5.67815 21.2884 2 16.0003 2C10.7122 2 6.06408 5.67815 3.39888 8.3317C2.69543 9.03206 2.34367 9.38246 2.11977 10.0699C1.96008 10.5601 1.96008 11.44 2.11977 11.9302C2.34367 12.6177 2.69543 12.9679 3.39888 13.6683Z",
    stroke: "black",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C11 13.7615 13.2385 16 16 16C18.7615 16 21 13.7615 21 11C21 8.2385 18.7615 6 16 6C13.2385 6 11 8.2385 11 11Z",
    stroke: "black",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeneyeBlackIcon);
export default __webpack_public_path__ + "static/media/openeye-black-icon.b6bb21095bb1371d55d7e6d3e5b3831c.svg";
export { ForwardRef as ReactComponent };